import {ClickerPageContainerWithBackground} from '@/ui/components/ClickerPageContainerWithBackground/ClickerPageContainerWithBackground';
import {PreloaderCustom} from '@/ui/kit/PreloaderCustom/PreloaderCustom';

export function ClickerPageLoader(): JSX.Element {
  return (
    <ClickerPageContainerWithBackground>
      <PreloaderCustom />
    </ClickerPageContainerWithBackground>
  );
}
